import { useAppSelector } from '@/store/hooks';
import { selectIsSingleSession } from '@/store/slices/project/selectors';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';

const ProjectEventTypePageSkeleton = () => {
  const isSingleSession = useAppSelector(selectIsSingleSession);

  return (
    <div data-component="ProjectEventTypePageSkeleton" className="padding-h-10 flex-column gap-16">
      <Container className="flex-column gap-10">
        {isSingleSession ? null : <Text skeletonLoader width="50%" height="20px" className="radius-12" />}
        <Text skeletonLoader width="70%" height="32px" className="radius-12" />
      </Container>

      <Container className="flex ai-flex-start" width="992px">
        <Container width="100%" className="flex gap-24" borderRadius="12px">
          <Container className="flex-column gap-16">
            <Container width="392px" height="220px" skeletonLoader borderRadius="12px" />

            <Container className="flex-column gap-8">
              <Container width="80px" height="16px" skeletonLoader borderRadius="12px" />
              <Container width="100%" className="flex gap-8 fw-wrap" borderRadius="12px">
                {Array.from({ length: 4 }).map((_, index) => (
                  <Container
                    background="var(--gray-900)"
                    key={index}
                    skeletonLoader
                    height="35px"
                    width="85px"
                    borderRadius="12px"
                  />
                ))}
              </Container>
            </Container>
          </Container>

          <Container width="calc(100% - 392px - 24px)" className="flex-column gap-16">
            <Container width="100%" height="116px" skeletonLoader borderRadius="12px" />
            <Container width="100%" height="64px" skeletonLoader borderRadius="12px" />
            <Container width="100%" height="56px" skeletonLoader borderRadius="12px" />
            <Container width="100%" height="64px" skeletonLoader borderRadius="12px" />
            <Container width="100%" height="64px" skeletonLoader borderRadius="12px" />
          </Container>
        </Container>
      </Container>

      <Container height="112px" width="100%">
        <Text skeletonLoader height="20px" width="100px" className="margin-b-8" />

        <Container width="100%" className="flex gap-8 flex-1" borderRadius="12px">
          {Array.from({ length: 5 }).map((_, index) => (
            <Container
              background="var(--gray-900)"
              key={index}
              skeletonLoader
              height="84px"
              className="flex-1"
              borderRadius="12px"
            />
          ))}
        </Container>
      </Container>

      <Container height="220px" width="100%">
        <Text skeletonLoader height="32px" width="100px" className="margin-b-8" />

        <Container width="100%" className="flex gap-16 flex-1" borderRadius="12px">
          {Array.from({ length: 3 }).map((_, index) => (
            <Container key={index} className="flex-column gap-4" width="100%" height="180px">
              <Container
                background="var(--gray-900)"
                skeletonLoader
                height="135px"
                className="flex-1"
                borderRadius="12px"
              />
              <Container height="36px" width="40%" background="var(--gray-900)" skeletonLoader borderRadius="12px" />
            </Container>
          ))}
        </Container>
      </Container>
    </div>
  );
};

export default ProjectEventTypePageSkeleton;
